var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('NewsBanner',{attrs:{"imageList":this.config.banner_top.imageList}}),_c('NewsTitle'),_c('NewsContent'),_c('NewsBanner3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }